// extracted by mini-css-extract-plugin
export default {"backdrop":"dialog_backdrop__DBrn+","dialog":"dialog_dialog__cooih","scrollable":"dialog_scrollable__g9KJU","opened":"dialog_opened__Gd-Hb","grounded":"dialog_grounded__GO331"};